import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            {aboutContent.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            国内领先的爆料吃瓜聚合平台
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              {aboutContent.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-8 pt-8 border-t border-background-200/60">
              {aboutContent.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-primary-600 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}